/** Public marketplace catalog — no CRM auth required. */
export function isMarketplacePublicRequest(url = '') {
  const path = String(url);
  if (!path.includes('/marketplace/')) return false;
  return !isMarketplaceBuyerAuthRequest(path);
}

/** Buyer-authenticated marketplace endpoints — JWT required. */
export function isMarketplaceBuyerAuthRequest(url = '') {
  const path = String(url);
  if (!path.includes('/marketplace/')) return false;
  return (
    path.includes('/marketplace/me/')
    || /\/marketplace\/properties\/[^/]+\/favourites/.test(path)
  );
}
